/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockUnitListCtrl
 */
angular.module('mercury.modules.stock.unit')
.controller('StockUnitListCtrl', ["$state", "dialog", "$scope", "ngToast", "StockUnits", "title", function($state, dialog, $scope, ngToast, StockUnits, title) {
  title.set('Stock Units');

  $scope.units = StockUnits.getAllManage();

  $scope.showDeleted = false;
  $scope.deletedFilter = function(unit) {
    return (unit.datestampDeleted !== null) == $scope.showDeleted;
  };

  $scope.unitTypes = [
    {value: 1, label: 'Weight (1 Kilo)'},
    {value: 2, label: 'Volume (1 Litre)'},
    {value: 3, label: 'Count (1 Each)'}
  ];

  $scope.updateUnit = function(unit, index) {
    if ($scope.unitsForm['name' + index].$invalid || $scope.unitsForm['ratio' + index].$invalid) {
      ngToast.danger('Unable to update unit due to invalid field');
      return;
    }

    unit.$update(
      function() { ngToast.success(unit.name + ' updated'); },
      function() { $state.reload(); }
    );
  };

  $scope.deleteUnit = function(unit) {
    StockUnits.remove(unit)
    .then(function() {
      unit.datestampDeleted = moment().format();
    });
  };

  $scope.restoreUnit = function(unit) {
    StockUnits.restore(unit)
    .then(function() {
      unit.datestampDeleted = null;
    });
  };

  $scope.addUnit = function() {
    StockUnits.create({
      name: 'New Unit',
      ratio: 1,
      unitType: 1
    })
    .then(function(newUnit) {
      $scope.units.push(newUnit);
      ngToast.success('Unit created');
    });
  };
}]);
